import React from 'react';
import { withTranslation } from 'react-i18next';
import {connect} from 'react-redux';
import Avatar from '../../../avatar/index';
import {API_ROOT} from '../../../../utils';
import Icon from '../../../icon';
import "./index.css";
import Button from '../../../button';
import {NavLink} from 'react-router-dom';

class ProfileInfo extends React.Component{

    constructor(props) {
        super(props);

        this.state = {
            toggleDropdown: false
        };

        this.handleClick = this.handleClick.bind(this);
        this.leaveHandler = this.leaveHandler.bind(this);
    }

    handleClick () {
        this.setState((state) => ({
            toggleDropdown: !state.toggleDropdown
        }));
    }

    leaveHandler () {
        this.setState({
            toggleDropdown: false
        });
    }

    render(){
        if(this.props.profile !== null){
	        return (
		        <div className="profile-info">
                    <div className="profile-info__welcome">
                        <p onClick={this.handleClick}>{this.props.t("textHi")} <strong>{this.props.profile.name}</strong></p>
	                    <p>{this.props.profile.email}</p>
                    </div>
                    <Avatar onClick={this.handleClick} size={36} src={`${API_ROOT}/account/avatar/${this.props.profile.id}`} alt={this.props.profile.name}/>
                    {
                        this.state.toggleDropdown &&
                        <div className="profile-info__details" onMouseLeave={this.leaveHandler}>
	                        <ul>
		                        <li>
			                        <NavLink className="text-nowrap" to={'/my-profile'}>
				                        <Icon name="user" className="mr-2"/>
				                        {this.props.t("myProfile")}
			                        </NavLink>
		                        </li>
		                        <li>
			                        <a className="text-nowrap" href={`${API_ROOT}/account/logout/`} onClick={() => window.webful?.reset()}>
				                        <Icon name="sign-out" className="mr-2"/>
				                        {this.props.t("textLogOut")}
			                        </a>
		                        </li>
	                        </ul>
                        </div>
                    }
                    <div>
	                    <Button className="expend" onClick={this.handleClick}><Icon name="ellipsis-v"/></Button>
                    </div>
		        </div>
	        )
        } else {
            return null
        }
    }
}

const mapStateToProps = (state) => {
	return {
		profile : state.profileReducer.getProfile
	};
};

export default connect(mapStateToProps)(withTranslation()(ProfileInfo));
